import {
    OPEN_ORDERS_POLL_INTERVAL_MS,
    OPEN_ORDERS_POLL_INTERVAL_MS_WHILE_REVISION_ACTIVE,
} from '../config/backgroundSyncConfig';

let revisionOrderMonitorActive = false;
let lastOpenOrdersRefreshAt = 0;
const intervalListeners: Array<() => void> = [];

export const subscribeOpenOrdersPollIntervalChange = (listener: () => void): (() => void) => {
    intervalListeners.push(listener);
    return () => {
        const idx = intervalListeners.indexOf(listener);
        if (idx !== -1) {
            intervalListeners.splice(idx, 1);
        }
    };
};

export const setRevisionOrderMonitorActive = (active: boolean) => {
    if (revisionOrderMonitorActive === active) {
        return;
    }
    revisionOrderMonitorActive = active;
    intervalListeners.forEach((listener) => listener());
};

export const isRevisionOrderMonitorActive = (): boolean => revisionOrderMonitorActive;

export const markOpenOrdersRefreshed = () => {
    lastOpenOrdersRefreshAt = Date.now();
};

/** Skip redundant GetMyOpenOrders when revision poll recently refreshed the list. */
export const shouldSkipOpenOrdersIntervalPoll = (): boolean => {
    if (!revisionOrderMonitorActive) {
        return false;
    }
    const elapsed = Date.now() - lastOpenOrdersRefreshAt;
    return elapsed < OPEN_ORDERS_POLL_INTERVAL_MS_WHILE_REVISION_ACTIVE;
};

export const openOrdersPollIntervalMs = (): number => {
    if (revisionOrderMonitorActive) {
        return OPEN_ORDERS_POLL_INTERVAL_MS_WHILE_REVISION_ACTIVE;
    }
    return OPEN_ORDERS_POLL_INTERVAL_MS;
};
